(function () {
  var data = window.ezPickupDrawerData;
  if (!data) return;

  // ─── Hardcoded business info — UPDATE HERE if hours change ─────────
  var WAREHOUSE_HOURS = [
    { day: 'Mon \u2013 Fri', hours: '8:30 AM \u2013 5:00 PM' },
    { day: 'Saturday',       hours: '8:30 AM \u2013 12:30 PM' },
    { day: 'Sunday',         hours: 'Closed' }
  ];

  // ─── Element refs ──────────────────────────────────────────────────
  var drawer   = document.getElementById('ezPickupDrawer');
  var backdrop = document.getElementById('ezPickupBackdrop');
  var closeBtn = document.getElementById('ezPickupDrawerClose');
  var titleEl  = document.getElementById('ezPickupDrawerTitle');
  var bodyEl   = document.getElementById('ezPickupDrawerBody');

// ─── Reparent to <body> so position:fixed escapes ancestor stacking contexts ─
if (drawer.parentNode !== document.body) {
  document.body.appendChild(backdrop);
  document.body.appendChild(drawer);
}

  if (!drawer || !backdrop) return;

  // ─── Render drawer body ────────────────────────────────────────────
  function buildBody() {
    var addressLine = data.address1 + (data.address2 ? ', ' + data.address2 : '');
    var cityLine    = data.city + ', ' + data.province + ' ' + data.zip;
    var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(addressLine + ', ' + cityLine);

    var statusBadge = '';
    if (data.pickUpEnabled && data.pickUpTime) {
      statusBadge =
        '<div class="ez-pickup-drawer-status">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M20 6L9 17l-5-5"></path>' +
          '</svg>' +
          '<span>' + data.pickUpTime + '</span>' +
        '</div>';
    }

    var hoursList = '';
    WAREHOUSE_HOURS.forEach(function (row) {
      hoursList +=
        '<div class="ez-pickup-drawer-hours-row">' +
          '<span class="ez-pickup-drawer-hours-day">'  + row.day   + '</span>' +
          '<span class="ez-pickup-drawer-hours-time">' + row.hours + '</span>' +
        '</div>';
    });

    var phoneClean = (data.phone || '').replace(/[^\d+]/g, '');
    var phoneSection = data.phone
      ? '<div class="ez-pickup-drawer-section">' +
          '<h3 class="ez-pickup-drawer-section-title">Phone</h3>' +
          '<a class="ez-pickup-drawer-link" href="tel:' + phoneClean + '">' + data.phone + '</a>' +
        '</div>'
      : '';

    bodyEl.innerHTML =
      statusBadge +
      '<div class="ez-pickup-drawer-section">' +
        '<h3 class="ez-pickup-drawer-section-title">Address</h3>' +
        '<p class="ez-pickup-drawer-address">' + addressLine + '<br>' + cityLine + '</p>' +
        '<a class="ez-pickup-drawer-directions-btn" href="' + directionsUrl + '" target="_blank" rel="noopener">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>' +
          '</svg>' +
          'Get Directions' +
        '</a>' +
      '</div>' +
      phoneSection +
      '<div class="ez-pickup-drawer-section">' +
        '<h3 class="ez-pickup-drawer-section-title">Hours</h3>' +
        '<div class="ez-pickup-drawer-hours">' + hoursList + '</div>' +
      '</div>';

    titleEl.textContent = 'Pickup at ' + data.city;
  }

  // ─── Focus management ──────────────────────────────────────────────
  var lastFocused = null;

  function getFocusable() {
    return drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key === 'Tab') {
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // ─── Open / Close ──────────────────────────────────────────────────
function open() {
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  lastFocused = document.activeElement;
  buildBody();
  drawer.classList.add('open');
  backdrop.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
  document.body.style.overflow = 'hidden';
  setTimeout(function () { closeBtn.focus(); }, 100);
  document.addEventListener('keydown', onKeyDown);
}

function close() {
  drawer.classList.remove('open');
  backdrop.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  if (lastFocused) lastFocused.focus();
  document.removeEventListener('keydown', onKeyDown);
}

  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);

  // ─── Public API for blocks to trigger ──────────────────────────────
  window.ezPickupDrawer = {
    open:  open,
    close: close
  };
})();
